import React, { useEffect, useState } from "react";
import { Upload, Button, Spin, Typography } from "antd";
import {
  DeleteOutlined,
  LoadingOutlined,
  PaperClipOutlined,
  SettingOutlined,
} from "@ant-design/icons";

import { RoleOptionsValues } from "../../helpers/constants";

const { Title, Text } = Typography;

const Dashboard = ({ state, actions }) => {
  const { manuals, uploadingType } = state;
  const [leasingAdminManual, setLeasingAdminManual] = useState(null);
  const [leasingKorisnikManual, setLeasingKorisnikManual] = useState(null);
  const [dobavljacAdminManual, setDobavljacAdminManual] = useState(null);
  const [dobavljacKorisnikManual, setDobavljacKorisnikManual] = useState(null);

  useEffect(() => {
    actions.getManuals();
  }, []);

  useEffect(() => {
    manuals.length > 0 &&
      manuals.map((manual) => {
        switch (manual.userRole) {
          case RoleOptionsValues.LEASING_ADMIN:
            return setLeasingAdminManual(manual);
          case RoleOptionsValues.LEASING_KORISNIK:
            return setLeasingKorisnikManual(manual);
          case RoleOptionsValues.DOBAVLJAC_ADMIN:
            return setDobavljacAdminManual(manual);
          case RoleOptionsValues.DOBAVLJAC_KORISNIK:
            return setDobavljacKorisnikManual(manual);
        }
      });
  }, [manuals]);

  const uploadUputstvoLA = (info) => {
    actions.uploadManual(info.file, RoleOptionsValues.LEASING_ADMIN);
  };
  const uploadUputstvoLK = (info) => {
    actions.uploadManual(info.file, RoleOptionsValues.LEASING_KORISNIK);
  };
  const uploadUputstvoDA = (info) => {
    actions.uploadManual(info.file, RoleOptionsValues.DOBAVLJAC_ADMIN);
  };
  const uploadUputstvoDK = (info) => {
    actions.uploadManual(info.file, RoleOptionsValues.DOBAVLJAC_KORISNIK);
  };
  /* 
  const openFile = (fileUrl) => {
    window.op
  }
 */
  const handleRemove = (manual) => {
    actions.manualDelete(manual.id);

    switch (manual.userRole) {
      case RoleOptionsValues.LEASING_ADMIN:
        return setLeasingAdminManual(null);
      case RoleOptionsValues.LEASING_KORISNIK:
        return setLeasingKorisnikManual(null);
      case RoleOptionsValues.DOBAVLJAC_ADMIN:
        return setDobavljacAdminManual(null);
      case RoleOptionsValues.DOBAVLJAC_KORISNIK:
        return setDobavljacKorisnikManual(null);
    }
  };

  return (
    <div className="p-8">
      <div className="mb-12">
        <Title className="text-lg font-bold text-dark-blue">
          LEASING ADMIN
        </Title>
        <div className="w-96">
          <Text className="mr-2">Uputstvo za korištenje</Text>
          <Upload
            disabled={leasingAdminManual}
            customRequest={uploadUputstvoLA}
            onRemove={handleRemove}
            showUploadList="false"
            multiple={false}
            maxCount={1}
            accept=".doc,.docx,.pdf"
          >
            <Button
              disabled={
                leasingAdminManual ||
                uploadingType === RoleOptionsValues.LEASING_ADMIN
              }
              icon={<SettingOutlined />}
            >
              Klikni da dodaš
            </Button>
          </Upload>
        </div>
        {uploadingType === RoleOptionsValues.LEASING_ADMIN && (
          <div className="mt-4 w-[450px] text-center ">
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
            />
            <Title className="text-light-blue-login text-sm font-bold mt-3">
              <>Ovo moze potrajati!</>
            </Title>
          </div>
        )}

        {leasingAdminManual && (
          <div className="mt-2">
            <div className="flex justify-between items-center  w-[450px]">
              <div className="flex">
                <PaperClipOutlined />
                <a
                  className="text-light-blue-login px-2 h-6 overflow-scroll cursor-pointer"
                  href={leasingAdminManual?.fileUrl}
                  target="_blank"
                >
                  {leasingAdminManual?.fileName}
                </a>
              </div>

              <Button
                onClick={() => handleRemove(leasingAdminManual)}
                type="dashed"
                className="px-2"
                icon={<DeleteOutlined />}
              ></Button>
            </div>
          </div>
        )}
      </div>
      <div className="mb-12">
        <Title className="text-lg font-bold text-dark-blue">
          LEASING KORISNIK
        </Title>
        <div className="w-96">
          <Text className="mr-2">Uputstvo za korištenje</Text>
          <Upload
            disabled={leasingKorisnikManual}
            customRequest={uploadUputstvoLK}
            onRemove={handleRemove}
            showUploadList="false"
            multiple={false}
            maxCount={1}
            accept=".doc,.docx,.pdf"
          >
            <Button
              disabled={
                leasingKorisnikManual ||
                uploadingType === RoleOptionsValues.LEASING_KORISNIK
              }
              icon={<SettingOutlined />}
            >
              Klikni da dodaš
            </Button>
          </Upload>
        </div>
        {uploadingType === RoleOptionsValues.LEASING_KORISNIK && (
          <div className="mt-4 w-[450px] text-center ">
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: 32 }} spin />}
            />
            <Title className="text-light-blue-login text-sm font-bold mt-3">
              <>Ovo moze potrajati!</>
            </Title>
          </div>
        )}
        {leasingKorisnikManual && (
          <div className="mt-2">
            <div className="flex justify-between items-center  w-[450px]">
              <div className="flex">
                <PaperClipOutlined />
                <a
                  className="text-light-blue-login px-2 h-6 overflow-scroll cursor-pointer"
                  href={dobavljacAdminManual?.fileUrl}
                  target="_blank"
                >
                  {leasingKorisnikManual?.fileName}
                </a>
              </div>

              <Button
                onClick={() => handleRemove(leasingKorisnikManual)}
                type="dashed"
                className="px-2"
                icon={<DeleteOutlined />}
              ></Button>
            </div>
          </div>
        )}
      </div>
      <div className="mb-12">
        <Title className="text-lg font-bold text-dark-blue">
          DOBAVLJAČ ADMIN
        </Title>
        <div className="w-96">
          <Text className="mr-2">Uputstvo za korištenje</Text>
          <Upload
            disabled={dobavljacAdminManual}
            customRequest={uploadUputstvoDA}
            onRemove={handleRemove}
            showUploadList="false"
            multiple={false}
            maxCount={1}
            accept=".doc,.docx,.pdf"
          >
            <Button
              disabled={
                dobavljacAdminManual ||
                uploadingType === RoleOptionsValues.DOBAVLJAC_ADMIN
              }
              icon={<SettingOutlined />}
            >
              Klikni da dodaš
            </Button>
          </Upload>
        </div>
        {uploadingType === RoleOptionsValues.DOBAVLJAC_ADMIN && (
          <div className="mt-4 w-[450px] text-center ">
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: 32 }} spin />}
            />
            <Title className="text-light-blue-login text-sm font-bold mt-3">
              <>Ovo moze potrajati!</>
            </Title>
          </div>
        )}
        {dobavljacAdminManual && (
          <div className="mt-2">
            <div className="flex justify-between items-center  w-[450px]">
              <div className="flex">
                <PaperClipOutlined />
                <a
                  href={dobavljacAdminManual?.fileUrl}
                  target="_blank"
                  className="text-light-blue-login px-2 h-6 overflow-scroll cursor-pointer"
                >
                  {dobavljacAdminManual?.fileName}
                </a>
              </div>

              <Button
                onClick={() => handleRemove(dobavljacAdminManual)}
                type="dashed"
                className="px-2"
                icon={<DeleteOutlined />}
              ></Button>
            </div>
          </div>
        )}
      </div>
      <div className="mb-12">
        <Title className="text-lg font-bold text-dark-blue">
          DOBAVLJAČ KORISNIK
        </Title>
        <div className="w-96">
          <Text className="mr-2">Uputstvo za korištenje</Text>
          <Upload
            disabled={dobavljacKorisnikManual}
            customRequest={uploadUputstvoDK}
            onRemove={handleRemove}
            showUploadList="false"
            multiple={false}
            maxCount={1}
            accept=".doc,.docx,.pdf"
          >
            <Button
              disabled={
                dobavljacKorisnikManual ||
                uploadingType === RoleOptionsValues.DOBAVLJAC_KORISNIK
              }
              icon={<SettingOutlined />}
            >
              Klikni da dodaš
            </Button>
          </Upload>
        </div>
        {uploadingType === RoleOptionsValues.DOBAVLJAC_KORISNIK && (
          <div className="mt-4 w-[450px] text-center ">
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: 32 }} spin />}
            />
            <Title className="text-light-blue-login text-sm font-bold mt-3">
              <>Ovo moze potrajati!</>
            </Title>
          </div>
        )}
        {dobavljacKorisnikManual && (
          <div className="mt-2">
            <div className="flex justify-between items-center  w-[450px]">
              <div className="flex">
                <PaperClipOutlined />
                <a
                  className="text-light-blue-login px-2 h-6 overflow-scroll cursor-pointer"
                  href={dobavljacKorisnikManual?.fileUrl}
                  target="_blank"
                >
                  {dobavljacKorisnikManual?.fileName}
                </a>
              </div>

              <Button
                onClick={() => handleRemove(dobavljacKorisnikManual)}
                type="dashed"
                className="px-2"
                icon={<DeleteOutlined />}
              ></Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
